import { defineMessages } from './define'

/* Words every screen uses, and the labels of the app's status values.
 *
 * Status keys end in the value the server sends, so a screen can write
 * t(`apptStatus.${a.status}`) and stay type-checked. */

export default defineMessages({
  en: {
    'common.save': 'Save',
    'common.saving': 'Saving…',
    'common.saved': 'Saved.',
    'common.cancel': 'Cancel',
    'common.close': 'Close',
    'common.back': 'Back',
    'common.next': 'Next',
    'common.continue': 'Continue',
    'common.done': 'Done',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.remove': 'Remove',
    'common.add': 'Add',
    'common.confirm': 'Confirm',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.ok': 'OK',
    'common.retry': 'Try again',
    'common.refresh': 'Refresh',
    'common.search': 'Search',
    'common.searching': 'Searching…',
    'common.loading': 'Loading…',
    'common.all': 'All',
    'common.none': 'None',
    'common.more': 'More',
    'common.less': 'Less',
    'common.seeAll': 'See all',
    'common.call': 'Call',
    'common.share': 'Share',
    'common.print': 'Print',
    'common.download': 'Download',
    'common.submit': 'Submit',
    'common.optional': 'Optional',
    'common.required': 'Required',
    'common.today': 'Today',
    'common.tomorrow': 'Tomorrow',
    'common.yesterday': 'Yesterday',
    'common.date': 'Date',
    'common.time': 'Time',
    'common.name': 'Name',
    'common.age': 'Age',
    'common.gender': 'Gender',
    'common.male': 'Male',
    'common.female': 'Female',
    'common.other': 'Other',
    'common.mobile': 'Mobile',
    'common.email': 'Email',
    'common.address': 'Address',
    'common.notes': 'Notes',
    'common.reason': 'Reason',
    'common.amount': 'Amount',
    'common.total': 'Total',
    'common.fee': 'Fee',
    'common.paid': 'Paid',
    'common.due': 'Due',
    'common.patient': 'Patient',
    'common.patients': 'Patients',
    'common.doctor': 'Doctor',
    'common.doctors': 'Doctors',
    'common.status': 'Status',
    'common.years': '{n} yrs',
    'common.minutes': '{n} min',
    'common.didNotWork': 'That did not work.',
    'common.couldNotLoad': 'Could not load this. Check the connection and try again.',
    'common.offline': 'You are offline.',
    'common.noResults': 'Nothing found',
    'common.signOut': 'Sign out',

    'visitType.new': 'New',
    'visitType.follow_up': 'Follow-up',
    'visitType.review': 'Review',
    'visitType.emergency': 'Emergency',

    'visitStatus.waiting': 'Waiting',
    'visitStatus.in_consult': 'In consult',
    'visitStatus.completed': 'Completed',
    'visitStatus.left_without_seeing': 'Left',

    'apptStatus.booked': 'Booked',
    'apptStatus.confirmed': 'Confirmed',
    'apptStatus.arrived': 'Arrived',
    'apptStatus.in_consult': 'In consult',
    'apptStatus.completed': 'Completed',
    'apptStatus.cancelled': 'Cancelled',
    'apptStatus.no_show': 'No-show',
    'apptStatus.rescheduled': 'Rescheduled',

    'payMode.cash': 'Cash',
    'payMode.upi': 'UPI',
    'payMode.card': 'Card',
    'payMode.net_banking': 'Net banking',
    'payMode.insurance': 'Insurance',
    'payMode.free': 'Free',
    'payMode.offline': 'Offline',

    'bookingPayMode.cash': 'Cash at clinic',
    'bookingPayMode.upi': 'UPI',
    'bookingPayMode.card': 'Card',
    'bookingPayMode.net_banking': 'Net banking',
    'bookingPayMode.insurance': 'Insurance',
    'bookingPayMode.free': 'No charge',
    'bookingPayMode.offline': 'Offline / transfer',

    'bookingPayStatus.pending': 'Pay at clinic',
    'bookingPayStatus.settled': 'Paid',

    'settlement.unpaid': 'Unpaid',
    'settlement.partial': 'Part paid',
    'settlement.paid': 'Paid',

    'medTiming.before_food': 'Before food',
    'medTiming.after_food': 'After food',
    'medTiming.with_food': 'With food',
    'medTiming.empty_stomach': 'Empty stomach',
    'medTiming.bedtime': 'Bedtime',

    'testUrgency.routine': 'Routine',
    'testUrgency.urgent': 'Urgent',
    'testUrgency.stat': 'STAT',

    'testStatus.advised': 'Advised',
    'testStatus.sample_taken': 'Sample taken',
    'testStatus.result_awaited': 'Awaiting result',
    'testStatus.result_received': 'Result received',

    'reminderKind.follow_up': 'Follow-up',
    'reminderKind.appointment_next_day': 'Appointment (next day)',

    'reminderStatus.pending': 'Pending',
    'reminderStatus.sent': 'Sent',
    'reminderStatus.failed': 'Failed',
    'reminderStatus.cancelled': 'Cancelled',

    'dow.0': 'Sun',
    'dow.1': 'Mon',
    'dow.2': 'Tue',
    'dow.3': 'Wed',
    'dow.4': 'Thu',
    'dow.5': 'Fri',
    'dow.6': 'Sat',
  },
  hi: {
    'common.save': 'सेव करें',
    'common.saving': 'सेव हो रहा है…',
    'common.saved': 'सेव हो गया।',
    'common.cancel': 'रद्द करें',
    'common.close': 'बंद करें',
    'common.back': 'वापस',
    'common.next': 'आगे',
    'common.continue': 'जारी रखें',
    'common.done': 'हो गया',
    'common.edit': 'बदलें',
    'common.delete': 'हटाएँ',
    'common.remove': 'हटाएँ',
    'common.add': 'जोड़ें',
    'common.confirm': 'पक्का करें',
    'common.yes': 'हाँ',
    'common.no': 'नहीं',
    'common.ok': 'ठीक है',
    'common.retry': 'फिर से कोशिश करें',
    'common.refresh': 'रीफ़्रेश करें',
    'common.search': 'खोजें',
    'common.searching': 'खोज रहे हैं…',
    'common.loading': 'लोड हो रहा है…',
    'common.all': 'सभी',
    'common.none': 'कोई नहीं',
    'common.more': 'और',
    'common.less': 'कम',
    'common.seeAll': 'सब देखें',
    'common.call': 'कॉल करें',
    'common.share': 'शेयर करें',
    'common.print': 'प्रिंट करें',
    'common.download': 'डाउनलोड करें',
    'common.submit': 'जमा करें',
    'common.optional': 'वैकल्पिक',
    'common.required': 'ज़रूरी',
    'common.today': 'आज',
    'common.tomorrow': 'कल',
    'common.yesterday': 'बीता कल',
    'common.date': 'तारीख',
    'common.time': 'समय',
    'common.name': 'नाम',
    'common.age': 'उम्र',
    'common.gender': 'लिंग',
    'common.male': 'पुरुष',
    'common.female': 'महिला',
    'common.other': 'अन्य',
    'common.mobile': 'मोबाइल',
    'common.email': 'ईमेल',
    'common.address': 'पता',
    'common.notes': 'नोट्स',
    'common.reason': 'कारण',
    'common.amount': 'राशि',
    'common.total': 'कुल',
    'common.fee': 'फ़ीस',
    'common.paid': 'भुगतान हो गया',
    'common.due': 'बकाया',
    'common.patient': 'मरीज़',
    'common.patients': 'मरीज़',
    'common.doctor': 'डॉक्टर',
    'common.doctors': 'डॉक्टर',
    'common.status': 'स्थिति',
    'common.years': '{n} वर्ष',
    'common.minutes': '{n} मिनट',
    'common.didNotWork': 'यह नहीं हो पाया।',
    'common.couldNotLoad': 'यह लोड नहीं हो सका। इंटरनेट जाँचें और फिर से कोशिश करें।',
    'common.offline': 'आप ऑफ़लाइन हैं।',
    'common.noResults': 'कुछ नहीं मिला',
    'common.signOut': 'साइन आउट',

    'visitType.new': 'नया',
    'visitType.follow_up': 'फ़ॉलो-अप',
    'visitType.review': 'रिव्यू',
    'visitType.emergency': 'इमरजेंसी',

    'visitStatus.waiting': 'इंतज़ार में',
    'visitStatus.in_consult': 'डॉक्टर के पास',
    'visitStatus.completed': 'पूरा हुआ',
    'visitStatus.left_without_seeing': 'चले गए',

    'apptStatus.booked': 'बुक',
    'apptStatus.confirmed': 'पक्का',
    'apptStatus.arrived': 'पहुँच गए',
    'apptStatus.in_consult': 'डॉक्टर के पास',
    'apptStatus.completed': 'पूरा हुआ',
    'apptStatus.cancelled': 'रद्द',
    'apptStatus.no_show': 'नहीं आए',
    'apptStatus.rescheduled': 'समय बदला',

    'payMode.cash': 'नकद',
    'payMode.upi': 'UPI',
    'payMode.card': 'कार्ड',
    'payMode.net_banking': 'नेट बैंकिंग',
    'payMode.insurance': 'बीमा',
    'payMode.free': 'मुफ़्त',
    'payMode.offline': 'ऑफ़लाइन',

    'bookingPayMode.cash': 'क्लिनिक पर नकद',
    'bookingPayMode.upi': 'UPI',
    'bookingPayMode.card': 'कार्ड',
    'bookingPayMode.net_banking': 'नेट बैंकिंग',
    'bookingPayMode.insurance': 'बीमा',
    'bookingPayMode.free': 'कोई शुल्क नहीं',
    'bookingPayMode.offline': 'ऑफ़लाइन / ट्रांसफ़र',

    'bookingPayStatus.pending': 'क्लिनिक पर भुगतान करें',
    'bookingPayStatus.settled': 'भुगतान हो गया',

    'settlement.unpaid': 'बाकी',
    'settlement.partial': 'आंशिक भुगतान',
    'settlement.paid': 'भुगतान हो गया',

    'medTiming.before_food': 'खाने से पहले',
    'medTiming.after_food': 'खाने के बाद',
    'medTiming.with_food': 'खाने के साथ',
    'medTiming.empty_stomach': 'खाली पेट',
    'medTiming.bedtime': 'सोते समय',

    'testUrgency.routine': 'सामान्य',
    'testUrgency.urgent': 'जल्दी',
    'testUrgency.stat': 'तुरंत (STAT)',

    'testStatus.advised': 'सलाह दी गई',
    'testStatus.sample_taken': 'सैंपल लिया गया',
    'testStatus.result_awaited': 'रिपोर्ट का इंतज़ार',
    'testStatus.result_received': 'रिपोर्ट आ गई',

    'reminderKind.follow_up': 'फ़ॉलो-अप',
    'reminderKind.appointment_next_day': 'अपॉइंटमेंट (अगले दिन)',

    'reminderStatus.pending': 'बाकी',
    'reminderStatus.sent': 'भेजा गया',
    'reminderStatus.failed': 'नहीं भेजा जा सका',
    'reminderStatus.cancelled': 'रद्द',

    'dow.0': 'रवि',
    'dow.1': 'सोम',
    'dow.2': 'मंगल',
    'dow.3': 'बुध',
    'dow.4': 'गुरु',
    'dow.5': 'शुक्र',
    'dow.6': 'शनि',
  },
  mr: {
    'common.save': 'सेव्ह करा',
    'common.saving': 'सेव्ह होत आहे…',
    'common.saved': 'सेव्ह झाले.',
    'common.cancel': 'रद्द करा',
    'common.close': 'बंद करा',
    'common.back': 'मागे',
    'common.next': 'पुढे',
    'common.continue': 'पुढे चला',
    'common.done': 'झाले',
    'common.edit': 'बदला',
    'common.delete': 'काढून टाका',
    'common.remove': 'काढा',
    'common.add': 'जोडा',
    'common.confirm': 'निश्चित करा',
    'common.yes': 'हो',
    'common.no': 'नाही',
    'common.ok': 'ठीक आहे',
    'common.retry': 'पुन्हा प्रयत्न करा',
    'common.refresh': 'रिफ्रेश करा',
    'common.search': 'शोधा',
    'common.searching': 'शोधत आहे…',
    'common.loading': 'लोड होत आहे…',
    'common.all': 'सर्व',
    'common.none': 'काहीही नाही',
    'common.more': 'अधिक',
    'common.less': 'कमी',
    'common.seeAll': 'सर्व पाहा',
    'common.call': 'कॉल करा',
    'common.share': 'शेअर करा',
    'common.print': 'प्रिंट करा',
    'common.download': 'डाउनलोड करा',
    'common.submit': 'पाठवा',
    'common.optional': 'ऐच्छिक',
    'common.required': 'आवश्यक',
    'common.today': 'आज',
    'common.tomorrow': 'उद्या',
    'common.yesterday': 'काल',
    'common.date': 'तारीख',
    'common.time': 'वेळ',
    'common.name': 'नाव',
    'common.age': 'वय',
    'common.gender': 'लिंग',
    'common.male': 'पुरुष',
    'common.female': 'स्त्री',
    'common.other': 'इतर',
    'common.mobile': 'मोबाइल',
    'common.email': 'ईमेल',
    'common.address': 'पत्ता',
    'common.notes': 'नोंदी',
    'common.reason': 'कारण',
    'common.amount': 'रक्कम',
    'common.total': 'एकूण',
    'common.fee': 'फी',
    'common.paid': 'पैसे भरले',
    'common.due': 'बाकी',
    'common.patient': 'रुग्ण',
    'common.patients': 'रुग्ण',
    'common.doctor': 'डॉक्टर',
    'common.doctors': 'डॉक्टर',
    'common.status': 'स्थिती',
    'common.years': '{n} वर्षे',
    'common.minutes': '{n} मिनिटे',
    'common.didNotWork': 'हे होऊ शकले नाही.',
    'common.couldNotLoad': 'हे लोड झाले नाही. इंटरनेट तपासा आणि पुन्हा प्रयत्न करा.',
    'common.offline': 'तुम्ही ऑफलाइन आहात.',
    'common.noResults': 'काहीही सापडले नाही',
    'common.signOut': 'साइन आउट',

    'visitType.new': 'नवीन',
    'visitType.follow_up': 'फॉलो-अप',
    'visitType.review': 'रिव्ह्यू',
    'visitType.emergency': 'इमर्जन्सी',

    'visitStatus.waiting': 'प्रतीक्षेत',
    'visitStatus.in_consult': 'डॉक्टरांकडे',
    'visitStatus.completed': 'पूर्ण',
    'visitStatus.left_without_seeing': 'निघून गेले',

    'apptStatus.booked': 'बुक',
    'apptStatus.confirmed': 'निश्चित',
    'apptStatus.arrived': 'आले',
    'apptStatus.in_consult': 'डॉक्टरांकडे',
    'apptStatus.completed': 'पूर्ण',
    'apptStatus.cancelled': 'रद्द',
    'apptStatus.no_show': 'आले नाहीत',
    'apptStatus.rescheduled': 'वेळ बदलली',

    'payMode.cash': 'रोख',
    'payMode.upi': 'UPI',
    'payMode.card': 'कार्ड',
    'payMode.net_banking': 'नेट बँकिंग',
    'payMode.insurance': 'विमा',
    'payMode.free': 'मोफत',
    'payMode.offline': 'ऑफलाइन',

    'bookingPayMode.cash': 'क्लिनिकमध्ये रोख',
    'bookingPayMode.upi': 'UPI',
    'bookingPayMode.card': 'कार्ड',
    'bookingPayMode.net_banking': 'नेट बँकिंग',
    'bookingPayMode.insurance': 'विमा',
    'bookingPayMode.free': 'शुल्क नाही',
    'bookingPayMode.offline': 'ऑफलाइन / ट्रान्सफर',

    'bookingPayStatus.pending': 'क्लिनिकमध्ये पैसे भरा',
    'bookingPayStatus.settled': 'पैसे भरले',

    'settlement.unpaid': 'बाकी',
    'settlement.partial': 'अंशतः भरले',
    'settlement.paid': 'पैसे भरले',

    'medTiming.before_food': 'जेवणापूर्वी',
    'medTiming.after_food': 'जेवणानंतर',
    'medTiming.with_food': 'जेवणासोबत',
    'medTiming.empty_stomach': 'उपाशीपोटी',
    'medTiming.bedtime': 'झोपताना',

    'testUrgency.routine': 'नेहमीची',
    'testUrgency.urgent': 'तातडीची',
    'testUrgency.stat': 'लगेच (STAT)',

    'testStatus.advised': 'सल्ला दिला',
    'testStatus.sample_taken': 'नमुना घेतला',
    'testStatus.result_awaited': 'रिपोर्टची प्रतीक्षा',
    'testStatus.result_received': 'रिपोर्ट आला',

    'reminderKind.follow_up': 'फॉलो-अप',
    'reminderKind.appointment_next_day': 'अपॉइंटमेंट (पुढचा दिवस)',

    'reminderStatus.pending': 'बाकी',
    'reminderStatus.sent': 'पाठवले',
    'reminderStatus.failed': 'पाठवता आले नाही',
    'reminderStatus.cancelled': 'रद्द',

    'dow.0': 'रवि',
    'dow.1': 'सोम',
    'dow.2': 'मंगळ',
    'dow.3': 'बुध',
    'dow.4': 'गुरु',
    'dow.5': 'शुक्र',
    'dow.6': 'शनि',
  },
  or: {
    'common.save': 'ସେଭ୍ କରନ୍ତୁ',
    'common.saving': 'ସେଭ୍ ହେଉଛି…',
    'common.saved': 'ସେଭ୍ ହେଲା।',
    'common.cancel': 'ବାତିଲ୍ କରନ୍ତୁ',
    'common.close': 'ବନ୍ଦ କରନ୍ତୁ',
    'common.back': 'ପଛକୁ',
    'common.next': 'ଆଗକୁ',
    'common.continue': 'ଜାରି ରଖନ୍ତୁ',
    'common.done': 'ହୋଇଗଲା',
    'common.edit': 'ବଦଳାନ୍ତୁ',
    'common.delete': 'ହଟାନ୍ତୁ',
    'common.remove': 'ହଟାନ୍ତୁ',
    'common.add': 'ଯୋଡନ୍ତୁ',
    'common.confirm': 'ନିଶ୍ଚିତ କରନ୍ତୁ',
    'common.yes': 'ହଁ',
    'common.no': 'ନା',
    'common.ok': 'ଠିକ ଅଛି',
    'common.retry': 'ପୁଣି ଚେଷ୍ଟା କରନ୍ତୁ',
    'common.refresh': 'ରିଫ୍ରେଶ୍ କରନ୍ତୁ',
    'common.search': 'ଖୋଜନ୍ତୁ',
    'common.searching': 'ଖୋଜୁଛି…',
    'common.loading': 'ଲୋଡ୍ ହେଉଛି…',
    'common.all': 'ସବୁ',
    'common.none': 'କିଛି ନାହିଁ',
    'common.more': 'ଅଧିକ',
    'common.less': 'କମ୍',
    'common.seeAll': 'ସବୁ ଦେଖନ୍ତୁ',
    'common.call': 'କଲ୍ କରନ୍ତୁ',
    'common.share': 'ସେୟାର୍ କରନ୍ତୁ',
    'common.print': 'ପ୍ରିଣ୍ଟ କରନ୍ତୁ',
    'common.download': 'ଡାଉନଲୋଡ୍ କରନ୍ତୁ',
    'common.submit': 'ଦାଖଲ କରନ୍ତୁ',
    'common.optional': 'ଇଚ୍ଛାଧୀନ',
    'common.required': 'ଆବଶ୍ୟକ',
    'common.today': 'ଆଜି',
    'common.tomorrow': 'ଆସନ୍ତାକାଲି',
    'common.yesterday': 'ଗତକାଲି',
    'common.date': 'ତାରିଖ',
    'common.time': 'ସମୟ',
    'common.name': 'ନାମ',
    'common.age': 'ବୟସ',
    'common.gender': 'ଲିଙ୍ଗ',
    'common.male': 'ପୁରୁଷ',
    'common.female': 'ମହିଳା',
    'common.other': 'ଅନ୍ୟ',
    'common.mobile': 'ମୋବାଇଲ୍',
    'common.email': 'ଇମେଲ୍',
    'common.address': 'ଠିକଣା',
    'common.notes': 'ଟିପ୍ପଣୀ',
    'common.reason': 'କାରଣ',
    'common.amount': 'ରାଶି',
    'common.total': 'ମୋଟ',
    'common.fee': 'ଫି',
    'common.paid': 'ଦେୟ ଦିଆଗଲା',
    'common.due': 'ବାକି',
    'common.patient': 'ରୋଗୀ',
    'common.patients': 'ରୋଗୀ',
    'common.doctor': 'ଡାକ୍ତର',
    'common.doctors': 'ଡାକ୍ତର',
    'common.status': 'ସ୍ଥିତି',
    'common.years': '{n} ବର୍ଷ',
    'common.minutes': '{n} ମିନିଟ୍',
    'common.didNotWork': 'ଏହା ହୋଇପାରିଲା ନାହିଁ।',
    'common.couldNotLoad': 'ଏହା ଲୋଡ୍ ହୋଇପାରିଲା ନାହିଁ। ଇଣ୍ଟରନେଟ୍ ଯାଞ୍ଚ କରି ପୁଣି ଚେଷ୍ଟା କରନ୍ତୁ।',
    'common.offline': 'ଆପଣ ଅଫଲାଇନ୍ ଅଛନ୍ତି।',
    'common.noResults': 'କିଛି ମିଳିଲା ନାହିଁ',
    'common.signOut': 'ସାଇନ୍ ଆଉଟ୍',

    'visitType.new': 'ନୂଆ',
    'visitType.follow_up': 'ଫଲୋ-ଅପ୍',
    'visitType.review': 'ରିଭ୍ୟୁ',
    'visitType.emergency': 'ଜରୁରୀକାଳୀନ',

    'visitStatus.waiting': 'ଅପେକ୍ଷାରେ',
    'visitStatus.in_consult': 'ଡାକ୍ତରଙ୍କ ପାଖରେ',
    'visitStatus.completed': 'ସମ୍ପୂର୍ଣ୍ଣ',
    'visitStatus.left_without_seeing': 'ଚାଲିଗଲେ',

    'apptStatus.booked': 'ବୁକ୍ ହୋଇଛି',
    'apptStatus.confirmed': 'ନିଶ୍ଚିତ',
    'apptStatus.arrived': 'ପହଞ୍ଚିଛନ୍ତି',
    'apptStatus.in_consult': 'ଡାକ୍ତରଙ୍କ ପାଖରେ',
    'apptStatus.completed': 'ସମ୍ପୂର୍ଣ୍ଣ',
    'apptStatus.cancelled': 'ବାତିଲ୍',
    'apptStatus.no_show': 'ଆସିଲେ ନାହିଁ',
    'apptStatus.rescheduled': 'ସମୟ ବଦଳିଲା',

    'payMode.cash': 'ନଗଦ',
    'payMode.upi': 'UPI',
    'payMode.card': 'କାର୍ଡ',
    'payMode.net_banking': 'ନେଟ୍ ବ୍ୟାଙ୍କିଙ୍ଗ',
    'payMode.insurance': 'ବୀମା',
    'payMode.free': 'ମାଗଣା',
    'payMode.offline': 'ଅଫଲାଇନ୍',

    'bookingPayMode.cash': 'କ୍ଲିନିକରେ ନଗଦ',
    'bookingPayMode.upi': 'UPI',
    'bookingPayMode.card': 'କାର୍ଡ',
    'bookingPayMode.net_banking': 'ନେଟ୍ ବ୍ୟାଙ୍କିଙ୍ଗ',
    'bookingPayMode.insurance': 'ବୀମା',
    'bookingPayMode.free': 'କୌଣସି ଶୁଳ୍କ ନାହିଁ',
    'bookingPayMode.offline': 'ଅଫଲାଇନ୍ / ଟ୍ରାନ୍ସଫର୍',

    'bookingPayStatus.pending': 'କ୍ଲିନିକରେ ଦେୟ ଦିଅନ୍ତୁ',
    'bookingPayStatus.settled': 'ଦେୟ ଦିଆଗଲା',

    'settlement.unpaid': 'ବାକି',
    'settlement.partial': 'ଆଂଶିକ ଦେୟ',
    'settlement.paid': 'ଦେୟ ଦିଆଗଲା',

    'medTiming.before_food': 'ଖାଇବା ପୂର୍ବରୁ',
    'medTiming.after_food': 'ଖାଇବା ପରେ',
    'medTiming.with_food': 'ଖାଇବା ସହିତ',
    'medTiming.empty_stomach': 'ଖାଲି ପେଟରେ',
    'medTiming.bedtime': 'ଶୋଇବା ସମୟରେ',

    'testUrgency.routine': 'ସାଧାରଣ',
    'testUrgency.urgent': 'ଜରୁରୀ',
    'testUrgency.stat': 'ତୁରନ୍ତ (STAT)',

    'testStatus.advised': 'ପରାମର୍ଶ ଦିଆଗଲା',
    'testStatus.sample_taken': 'ନମୁନା ନିଆଗଲା',
    'testStatus.result_awaited': 'ରିପୋର୍ଟ ଅପେକ୍ଷାରେ',
    'testStatus.result_received': 'ରିପୋର୍ଟ ଆସିଗଲା',

    'reminderKind.follow_up': 'ଫଲୋ-ଅପ୍',
    'reminderKind.appointment_next_day': 'ଆପଏଣ୍ଟମେଣ୍ଟ (ପରଦିନ)',

    'reminderStatus.pending': 'ବାକି',
    'reminderStatus.sent': 'ପଠାଗଲା',
    'reminderStatus.failed': 'ପଠାଯାଇପାରିଲା ନାହିଁ',
    'reminderStatus.cancelled': 'ବାତିଲ୍',

    'dow.0': 'ରବି',
    'dow.1': 'ସୋମ',
    'dow.2': 'ମଙ୍ଗଳ',
    'dow.3': 'ବୁଧ',
    'dow.4': 'ଗୁରୁ',
    'dow.5': 'ଶୁକ୍ର',
    'dow.6': 'ଶନି',
  },
})
